import React, { useState } from 'react';
import { Button } from '../UI/Button';
interface ApplicationFormProps {
  onFormSubmit: () => void;
}
export const ApplicationForm = ({
  onFormSubmit
}: ApplicationFormProps) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    experience: '',
    pastExperience: '',
    motivation: '',
    hours: '',
    linkedin: '',
    instagram: '',
    facebook: '',
    twitter: '',
    hasAttendedEvent: '',
    eventAttended: '',
    notes: '',
    consent: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      const response = await fetch('https://formspree.io/f/xanppkda', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          location: '',
          role: '',
          experience: '',
          pastExperience: '',
          motivation: '',
          hours: '',
          linkedin: '',
          instagram: '',
          facebook: '',
          twitter: '',
          hasAttendedEvent: '',
          eventAttended: '',
          notes: '',
          consent: false
        });
        // Call the parent component's callback to show the thank you page
        onFormSubmit();
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (err) {
      setError('There was an error submitting your application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="bg-white p-6 rounded-lg border-2 border-gray-200" data-id="element-606">
      <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-607">
        The Networking Salon — Team Application (Contract Roles)
      </h3>
      <p className="text-gray-600 mb-6" data-id="element-608">
        We're excited that you're interested in joining The Networking Salon!
        Please fill out this short form carefully. It helps us learn about your
        experience, interests, and how you can contribute to our growing
        community.
      </p>
      <p className="text-gray-600 mb-6" data-id="element-609">
        These are contract-based roles (3–6 months, renewable) — part-time,
        remote or hybrid, and performance/commission-based.
      </p>
      {error && <div className="bg-red-50 border border-red-200 text-red-800 p-4 rounded-md mb-6" data-id="element-610">
          {error}
        </div>}
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-611">
        <div className="space-y-4" data-id="element-612">
          <div data-id="element-613">
            <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-614">
              Full Name
            </label>
            <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-615" />
          </div>
          <div data-id="element-616">
            <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-617">
              Email Address
            </label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-618" />
          </div>
          <div data-id="element-619">
            <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-620">
              Phone Number (WhatsApp Preferred)
            </label>
            <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-621" />
          </div>
          <div data-id="element-622">
            <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-623">
              City & State of Residence
            </label>
            <input type="text" id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-624" />
          </div>
          <div data-id="element-625">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-626">
              Have you ever attended any of The Networking Salon events?
            </label>
            <div className="space-y-2" data-id="element-627">
              {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-628">
                  <input type="radio" id={`hasAttendedEvent-${option}`} name="hasAttendedEvent" value={option} checked={formData.hasAttendedEvent === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-629" />
                  <label htmlFor={`hasAttendedEvent-${option}`} className="text-gray-700" data-id="element-630">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          {formData.hasAttendedEvent === 'Yes' && <div data-id="element-631">
              <label className="block text-gray-700 font-medium mb-1" data-id="element-632">
                Which event(s) did you attend? (Select all that apply)
              </label>
              <select name="eventAttended" value={formData.eventAttended} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-633">
                <option value="" data-id="element-634">Select an event</option>
                <option value="Abuja" data-id="element-635">Abuja</option>
                <option value="Port Harcourt" data-id="element-636">Port Harcourt</option>
                <option value="Benin" data-id="element-637">Benin</option>
                <option value="Lagos" data-id="element-638">Lagos</option>
                <option value="Warri" data-id="element-639">Warri</option>
                <option value="Berlin" data-id="element-640">Berlin</option>
                <option value="Houston Texas" data-id="element-641">Houston Texas</option>
                <option value="Virtual Coffee Chat" data-id="element-642">Virtual Coffee Chat</option>
                <option value="Other" data-id="element-643">Other</option>
              </select>
            </div>}
          <div data-id="element-644">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-645">
              Which role are you applying for?
            </label>
            <div className="space-y-2" data-id="element-646">
              {['Community & Programs Lead', 'Content & Communications Lead', 'Tech & Systems Support'].map(option => <div key={option} className="flex items-center" data-id="element-647">
                  <input type="radio" id={`role-${option}`} name="role" value={option} checked={formData.role === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-648" />
                  <label htmlFor={`role-${option}`} className="text-gray-700" data-id="element-649">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          <div data-id="element-650">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-651">
              Have you played this role before or done something similar?
            </label>
            <div className="space-y-2" data-id="element-652">
              {['Yes, I have experience in this exact role', "I've done something similar",, "I'm new to this but eager to learn"].map(option => <div key={option} className="flex items-center" data-id="element-653">
                  <input type="radio" id={`experience-${option}`} name="experience" value={option} checked={formData.experience === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-654" />
                  <label htmlFor={`experience-${option}`} className="text-gray-700" data-id="element-655">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          <div data-id="element-656">
            <label htmlFor="pastExperience" className="block text-gray-700 font-medium mb-1" data-id="element-657">
              Briefly describe your past experience or related work
              <span className="block text-sm text-gray-500" data-id="element-658">
                (Include any events, communities, or projects you've managed or
                contributed to.)
              </span>
            </label>
            <textarea id="pastExperience" name="pastExperience" value={formData.pastExperience} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-659" />
          </div>
          <div data-id="element-660">
            <label htmlFor="motivation" className="block text-gray-700 font-medium mb-1" data-id="element-661">
              What excites you about joining The Networking Salon team?
            </label>
            <textarea id="motivation" name="motivation" value={formData.motivation} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-662" />
          </div>
          <div data-id="element-663">
            <label className="block text-gray-700 font-medium mb-1" data-id="element-664">
              How many hours a week can you commit to this role?
            </label>
            <div className="space-y-2" data-id="element-665">
              {['Less than 5 hours', '5–10 hours', '10–15 hours', 'More than 15 hours'].map(option => <div key={option} className="flex items-center" data-id="element-666">
                  <input type="radio" id={`hours-${option}`} name="hours" value={option} checked={formData.hours === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-667" />
                  <label htmlFor={`hours-${option}`} className="text-gray-700" data-id="element-668">
                    {option}
                  </label>
                </div>)}
            </div>
          </div>
          <div data-id="element-669">
            <label className="block text-gray-700 font-medium mb-3" data-id="element-670">
              Social Media Links (for reference & engagement)
            </label>
            <div className="space-y-3" data-id="element-671">
              <div data-id="element-672">
                <label htmlFor="linkedin" className="block text-gray-600 text-sm mb-1" data-id="element-673">
                  LinkedIn Profile
                </label>
                <input type="text" id="linkedin" name="linkedin" value={formData.linkedin} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-674" />
              </div>
              <div data-id="element-675">
                <label htmlFor="instagram" className="block text-gray-600 text-sm mb-1" data-id="element-676">
                  Instagram Handle
                </label>
                <input type="text" id="instagram" name="instagram" value={formData.instagram} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-677" />
              </div>
              <div data-id="element-678">
                <label htmlFor="facebook" className="block text-gray-600 text-sm mb-1" data-id="element-679">
                  Facebook Profile
                </label>
                <input type="text" id="facebook" name="facebook" value={formData.facebook} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-680" />
              </div>
              <div data-id="element-681">
                <label htmlFor="twitter" className="block text-gray-600 text-sm mb-1" data-id="element-682">
                  X (Twitter) Handle
                </label>
                <input type="text" id="twitter" name="twitter" value={formData.twitter} onChange={handleChange} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-683" />
              </div>
            </div>
          </div>
          <div data-id="element-684">
            <label htmlFor="notes" className="block text-gray-700 font-medium mb-1" data-id="element-685">
              Any other notes or message for us?
            </label>
            <textarea id="notes" name="notes" value={formData.notes} onChange={handleChange} rows={3} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus-outline-none focus-ring-2 focus-ring-gray-400" data-id="element-686" />
          </div>
          <div className="pt-2" data-id="element-687">
            <div className="flex items-start" data-id="element-688">
              <input type="checkbox" id="consent" name="consent" checked={formData.consent} onChange={handleChange} required className="mr-2 mt-1 h-4 w-4 border-2 border-gray-300" data-id="element-689" />
              <label htmlFor="consent" className="text-gray-700" data-id="element-690">
                I confirm that the information I've provided is accurate and
                that I understand this is a part-time, contract-based
                opportunity with performance-linked compensation.
              </label>
            </div>
          </div>
        </div>
        <div className="pt-2" data-id="element-691">
          <Button type="submit" disabled={isSubmitting} className="w-full py-3" data-id="element-692">
            {isSubmitting ? 'Submitting...' : 'Submit Application'}
          </Button>
        </div>
      </form>
    </div>;
};